import { render, staticRenderFns } from "./NsProductSkuPoints.vue?vue&type=template&id=029d7203&"
import script from "./NsProductSkuPoints.vue?vue&type=script&lang=js&"
export * from "./NsProductSkuPoints.vue?vue&type=script&lang=js&"
import style0 from "./NsProductSkuPoints.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports